import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { JWT } from '@r1-compass-library/models';
import { TokenTypes } from '@r1-compass-library/services/login.service';
import { BehaviorSubject, catchError, filter, map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
    readonly #jwtClaimsString$ = new BehaviorSubject<string | null>(null);

    constructor() {
        const token = localStorage.getItem(TokenTypes.Jwt);
        if (token) {
            this.#jwtClaimsString$.next(token);
        }
    }

    readonly #jwtClaims$: Observable<JWT | null> = this.#jwtClaimsString$.pipe(
        filter(str => str !== '' && str !== null),
        map(jwtStr => JSON.parse(atob(jwtStr!.split('.')[1]))),
        catchError(error => {
            console.error(error);
            return of<null>();
        })
    );
    public readonly jwtClaims = toSignal(this.#jwtClaims$, { initialValue: null });

    public setItem(key: string, value: string): void {
        localStorage.setItem(key, value);
        if (key === TokenTypes.Jwt) {
            this.#jwtClaimsString$.next(value);
        }
    }

    public getItem(key: string): string | null {
        return localStorage.getItem(key);
    }

    public removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    public clear(): void {
        localStorage.clear();
    }
}
